import React, {useState} from 'react';
import {UserContext} from '../../utils/usercontext';
import {postApi} from '../../utils/functions';

import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';

class PaypalPayment extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
      status: false,
      
    };
  }

  async componentDidMount() {

    let params = new URLSearchParams();
		//const x = await postApi('/v3/payment/payment', params);
		//console.log(x.data);
    //this.setState({status: true, sdk: x.data});

  }

  render() {
    return (
      <>
        Add Card
      </>
    )
  }
}

export default PaypalPayment;